import React, { useState, useEffect } from "react";
import DeepLinkHelper from "../helper/deepLinkHelper";

const OpenInAppBanner = ({ productId, productName }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Only show on mobile devices
    if (DeepLinkHelper.isMobileDevice()) {
      // Check if user previously dismissed
      const dismissedKey = "app_banner_dismissed";
      const wasDismissed = sessionStorage.getItem(dismissedKey);

      if (!wasDismissed) {
        // Show banner after a short delay
        setTimeout(() => {
          setIsVisible(true);
        }, 2000);
      }
    }
  }, []);

  const handleOpenInApp = () => {
    console.log("🔗 [BANNER] Open in App clicked");
    DeepLinkHelper.tryOpenInApp(productId, () => {
      // If app doesn't open, show download option
      const shouldDownload = window.confirm(
        "K9 Interior app is not installed. Would you like to download it?"
      );
      if (shouldDownload) {
        DeepLinkHelper.openAppStore();
      }
    });
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
    sessionStorage.setItem("app_banner_dismissed", "true");
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#0C831F",
        color: "white",
        padding: "15px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
        zIndex: 9999,
        animation: "slideUp 0.3s ease-out",
      }}
    >
      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(100%);
            }
            to {
              transform: translateY(0);
            }
          }
        `}
      </style>

      <div style={{ flex: 1 }}>
        <div
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "4px" }}
        >
          📱 K9 Interior App
        </div>
        <div style={{ fontSize: "13px", opacity: 0.9 }}>
          Better experience in our app!
        </div>
      </div>

      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <button
          onClick={handleOpenInApp}
          style={{
            backgroundColor: "white",
            color: "#0C831F",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            fontWeight: "bold",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          OPEN
        </button>

        <button
          onClick={handleDismiss}
          style={{
            backgroundColor: "transparent",
            color: "white",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            padding: "0",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default OpenInAppBanner;
